import DateFormatterUtils from '../utils/date-formatter-utils';

export default function (value, includeTime = false) {
  if (!value) {
    return '';
  }
  return DateFormatterUtils.formatDateTime(value, includeTime);
}
